module.exports = __webpack_public_path__ + "img/DEFAULT.b4f6390a.png";